export default "__VITE_ASSET__B47UN$DD__"